import api from "../instance/axios_instance.ts";
const DisbursementOfficeApi = async (): Promise<any> => {

    try {
        const response = await api.get('/disbursement_office', { skipAuth: true } as any);
        return response;        
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default DisbursementOfficeApi;